/*
 * navigation menu click
 */
const navMenuClick = function() {

	const navOpenBtn = $('.js-nav-open');
	const navCloseBtn = $('.js-nav-close');

	navOpenBtn.click(function() {
		navOpen();
	});

	navCloseBtn.click(function() {
		navClose();
	});
}


/*
 * open navigation
 */
const navOpen = function() {

	const header = $('.js-header');
	const nav = $('.js-nav');
	const currentScrollY = $(window).scrollTop();

	header.removeClass('is-close').addClass('is-open');
	nav.scrollTop(0);
	$('body').addClass('is-fixed').css({'top': - currentScrollY});
}


/*
 * close navigation
 */
const navClose = function() {

	const header = $('.js-header');
	const scrollY = - parseInt($('body').css('top'));

	$('body').removeClass('is-fixed').css({'top': ''});
	$(window).scrollTop(scrollY);

	header.removeClass('is-open').addClass('is-close');
}


/*
 * close navigation when anchored
 */
const navCloseAnchored = function() {
	if ($(window).outerWidth() <= 1024) {
		$('.js-nav a[href*="#"]:not(.js-modal)').click(function() {
			const href = $(this).attr('href');

			// hrefが存在しない場合は何もしない
			if (!href) return;

			// ナビ内の # 単体はページ先頭リンクとしてメニューを閉じる
			if (href === '#') {
				navClose();
				return;
			}

			// 現在ページとクリック先URLを解析
			const url = new URL(href, location.href);

			// 「同一ページ内のハッシュリンク」判定
			const isSameOrigin = url.origin === location.origin;
			const isSamePath = url.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');

			if (isSameOrigin && isSamePath && url.hash) {
				// 同一ページ内アンカーなのでメニューを閉じる
				navClose();
			}
		});
	}
};


/*
 * init
 */
navMenuClick();
navCloseAnchored();
